import { render } from "./RefundGoods.vue?vue&type=template&id=34f486a8"
import script from "./RefundGoods.vue?vue&type=script&lang=js"
export * from "./RefundGoods.vue?vue&type=script&lang=js"

import "./RefundGoods.vue?vue&type=style&index=0&id=34f486a8&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__